import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postCompleatFoodForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine/index";
import buildAddress from "./helpers";

const NewStarterDetailsForm = ({ appData, postForm }) => {
  const initialData = {
    // personal  details
    startDate: "",
    continuousServiceDate: "",
    title: appData.title,
    firstName: appData.firstName,
    lastName: appData.lastName,
    nationalInsuranceNumber: appData.nationalInsuranceNo,
    dateOfBirth: appData.dateOfBirth,
    homeAddress: buildAddress(appData),
    postcode: appData.address && appData.address.postcode,
    nationality: "",
    emailAddress: appData.emailAddress,
    mobileTelephone: appData.mobileTelephone,
    homeTelephone: appData.homeTelephone,
    ethicOfOrigin: "",
    // bank details
    bankName: appData.bankName,
    bankAddress: appData.bankAddress,
    accountName: appData.accountName,
    sortCode: appData.sortCode,
    accountNumber: appData.accountNumber,
    signature: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
    // next of kin  details
    nextOfKinName: "",
    nextOfKinAddress: "",
    nextOfKinPhone: "",
    nextOfKinRelationship: "",
    // emergency contact details
    emergencyContactName: "",
    emergencyContactAddress: "",
    emergencyContactPhone: "",
    emergencyContactRelationship: "",
    // passport details
    exactNameInPassport: "",
    passportNumber: "",
    passportIssueDate: "",
    passportExpiryDate: "",
    passportIssuingCountry: "",
    // permitpassport details
    exactNameInPermit: "",
    permitRefNumber: "",
    permitValidFrom: "",
    permitExpiryDate: "",
    permitIssuingCountry: "",
    permitType: "",
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: <HorizontalLine text="Personal Details" />,
    },
    startDate: {
      type: "date",
      title: "Start Date",
      value: getVal("startDate"),
      mandatory: true,
    },
    continuousServiceDate: {
      type: "date",
      title: "Continuous Service Date",
      value: getVal("continuousServiceDate"),
    },
    title: {
      title: "Title",
      value: getVal("title"),
      type: "radio",
      radioOptions: ["Mr", "Mrs", "Ms", "Miss"],
      mandatory: true,
    },
    firstName: {
      title: "Forename/s",
      value: getVal("firstName"),
      mandatory: true,
    },
    lastName: {
      title: "Surname/Family Name",
      value: getVal("lastName"),
      mandatory: true,
    },
    nationalInsuranceNumber: {
      title: "National Insurance Number",
      value: getVal("nationalInsuranceNumber"),
      mandatory: true,
    },
    dateOfBirth: {
      type: "date",
      title: "Date of Birth",
      value: getVal("dateOfBirth"),
      mandatory: true,
    },
    homeAddress: {
      title: "Home Address",
      value: getVal("homeAddress"),
      mandatory: true,
    },
    postcode: {
      title: "Post code",
      value: getVal("postcode"),
      mandatory: true,
    },
    emailAddress: {
      title: "E-mail address",
      value: getVal("emailAddress"),
      mandatory: true,
    },
    homeTelephone: {
      title: "Home Telephone Number",
      value: getVal("homeTelephone"),
      mandatory: true,
    },
    mobileTelephone: {
      title: "Mobile Telephone Number",
      value: getVal("mobileTelephone"),
      mandatory: true,
    },
    nationality: {
      title: "Nationality",
      value: getVal("nationality"),
      mandatory: true,
    },
    ethicOfOrigin: {
      title: "Ethnic Origin",
      value: getVal("ethicOfOrigin"),
      mandatory: true,
    },
    blurb2: {
      htmlObj: (
        <div>
          <HorizontalLine text="Bank Details" />
          <p className={"mt-2"}>
            I agree to have my Salary/Wages paid into my Bank/Building Society
            from my first pay day.
          </p>
        </div>
      ),
    },
    signature: {
      title: "Signed",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
    bankName: {
      title: "Bank Name",
      value: getVal("bankName"),
      mandatory: true,
    },
    bankAddress: {
      title: "Bank Address",
      value: getVal("bankAddress"),
      mandatory: true,
    },
    accountName: {
      title: "Account Name",
      value: getVal("accountName"),
      mandatory: true,
    },
    sortCode: {
      type: "number",
      title: "Sort Code",
      value: getVal("sortCode"),
      mandatory: true,
    },
    accountNumber: {
      type: "number",
      title: "Account Number",
      value: getVal("accountNumber"),
      mandatory: true,
    },

    blurb3: {
      htmlObj: <HorizontalLine text="Next Of Kin Details" />,
    },
    nextOfKinName: {
      title: "Name",
      value: getVal("nextOfKinName"),
      mandatory: true,
    },
    nextOfKinAddress: {
      title: "Address",
      value: getVal("nextOfKinAddress"),
      mandatory: true,
    },
    nextOfKinPhone: {
      title: "Telephone Number",
      value: getVal("nextOfKinPhone"),
      mandatory: true,
    },
    nextOfKinRelationship: {
      title: "Relationship",
      value: getVal("nextOfKinRelationship"),
      mandatory: true,
    },
    blurb4: {
      htmlObj: (
        <HorizontalLine text="Emergency Contact (if different from next of kin)" />
      ),
    },
    emergencyContactName: {
      title: "Name",
      value: getVal("emergencyContactName"),
    },
    emergencyContactAddress: {
      title: "Address",
      value: getVal("emergencyContactAddress"),
    },
    emergencyContactPhone: {
      title: "Phone",
      value: getVal("emergencyContactPhone"),
    },
    emergencyContactRelationship: {
      title: "Relationship",
      value: getVal("emergencyContactRelationship"),
    },
    blurb5: {
      htmlObj: <HorizontalLine text="Passport Details" />,
    },
    exactNameInPassport: {
      title: "Name (as shown on passport)",
      value: getVal("exactNameInPassport"),
    },
    passportNumber: {
      title: "Passport Number",
      value: getVal("passportNumber"),
    },
    passportIssueDate: {
      title: "Date Issued",
      value: getVal("passportIssueDate"),
    },
    passportExpiryDate: {
      title: "Date Expires",
      value: getVal("passportExpiryDate"),
    },
    passportIssuingCountry: {
      title: "Issuing Country",
      value: getVal("passportIssuingCountry"),
    },
    blurb6: {
      htmlObj: <HorizontalLine text="Work Permit Details" />,
    },
    exactNameInPermit: {
      title: "Name (as shown on permit)",
      value: getVal("exactNameInPermit"),
    },
    permitRefNumber: {
      title: "Reference Number",
      value: getVal("permitRefNumber"),
    },
    permitValidFrom: {
      title: "Valid From",
      value: getVal("permitValidFrom"),
    },
    permitExpiryDate: {
      title: "Expiry Date",
      value: getVal("permitExpiryDate"),
    },
    permitIssuingCountry: {
      title: "Issuing Country",
      value: getVal("permitIssuingCountry"),
    },
    permitType: {
      title: "Type of Permit",
      value: getVal("permitType"),
    },
  };
  const [fields, setField] = useForm(initialState);

  const submitted =
    appData.compleatFoodOnboarding && appData.compleatFoodOnboarding.YCF1;

  const redirectBack = () => {
    history.push("/profile/edit/compleat-food-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postForm("YCF1", {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"New Starter Details V.1"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"compleatFood"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

NewStarterDetailsForm.propTypes = {
  appData: any,
  postForm: func,
};

const mapDispatchToProps = {
  postForm: postCompleatFoodForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(NewStarterDetailsForm);
